module.exports = __webpack_public_path__ + "static/media/home-001.f5e9ed8a.jpg";